import { createSelector } from '@reduxjs/toolkit';
import { selectMatrixFromSearchState } from 'component/page/search/store/search.selectors';

export interface OwnProps {
    isLoading: boolean;
}

interface StateProps {
    hasFilterData: boolean;
}

export type Props = OwnProps & StateProps;

export const mapStateToProps = createSelector(selectMatrixFromSearchState, (matrix) => {
    const sortMatrix = matrix?.sort || {};
    const filterMatrix = matrix?.filter || {};
    const hasFilterData = Object.keys(filterMatrix).length > 0 || Object.keys(sortMatrix).length > 0;

    return { hasFilterData };
});
